import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldAlert } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const RiskBadge = ({ phone, token }) => {
  const [risk, setRisk] = useState(null);
  useEffect(() => {
    if (!phone) return;
    axios.get(`${API}/leakage/risk-check`, { params: { phone }, headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setRisk(data))
      .catch(() => {});
  }, [phone, token]);
  if (!risk || (risk.risk === "Low Risk" && risk.eligibility === "Approved")) return null;
  const high = risk.risk === "High Risk" || risk.eligibility === "Do Not Rent";
  return (
    <span data-testid="late-risk-badge" title={`${risk.incidents} late incident(s) · ${risk.total_days_late || 0} days late · $${risk.outstanding || 0} outstanding · ${risk.broken_promises || 0} broken promise(s)`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold border ${high
        ? "bg-red-500/15 border-red-500 text-red-300" : "bg-amber-400/15 border-amber-400/60 text-amber-300"}`}>
      <ShieldAlert size={10} /> {risk.risk.toUpperCase()}{risk.eligibility !== "Approved" ? ` · ${risk.eligibility.toUpperCase()}` : ""}
    </span>
  );
};

export default RiskBadge;
